import { AnyAction, Dispatch } from 'redux';
import { AppThunkDispatch } from 'src/store';

// Returning dispatch instead of a wrapped dispatch causes an infinite loop with thunk
export const wrappedDispatch = (dispatch: Dispatch<AnyAction>) => ({ dispatch });
export interface WrappedDispatch extends ReturnType<typeof wrappedDispatch> {}

export const wrappedThunkDispatch = (dispatch: AppThunkDispatch) => ({ dispatch });
export interface WrappedThunkDispatch extends ReturnType<typeof wrappedThunkDispatch> {}
